import { render, staticRenderFns } from "./startBlockLayout.vue?vue&type=template&id=c6d005be&scoped=true&"
var script = {}
import style0 from "./startBlockLayout.vue?vue&type=style&index=0&id=c6d005be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6d005be",
  null
  
)

export default component.exports